<template>
    <div v-if="shouldShowMenu" class="drop-menu-container">
        <div class="drop-menu" :style="menuStyle">
            <!-- Главная страница -->
            <div 
                class="drop-menu-page" 
                :class="{ 'page-selected': isHomePage }"
                @click="goToHome"
            >
                <img 
                    :src="isHomePage ? homeSelectedIcon : homeIcon" 
                    alt="Иконка домика" 
                    class="menu-logo"
                >
                <div class="menu-label">Главная</div>
            </div>

            <!-- Личный кабинет -->
            <div 
                class="drop-menu-page" 
                :class="{ 'page-selected': isProfilePage }"
                @click="goToProfile"
            >
                <img 
                    :src="isProfilePage ? userSelectedIcon : userIcon" 
                    alt="Иконка пользователя" 
                    class="menu-logo"
                >
                <div class="menu-label">Профиль</div>
            </div>

            <!-- Менеджер (только для админов) -->
            <div 
                v-if="isAdmin"
                class="drop-menu-page" 
                :class="{ 'page-selected': isManagerPage }"
                @click="goToManager"
            >
                <img 
                    :src="isManagerPage ? managerSelected : manager" 
                    alt="Иконка менеджера" 
                    class="menu-logo"   
                >
                <div class="menu-label">Менеджер</div>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: 'DropMenu',
    data() {
        return {
            homeIcon: require('../assets/icons/home.png'),
            homeSelectedIcon: require('../assets/icons/home-selected.png'),
            userIcon: require('../assets/icons/user.png'),
            userSelectedIcon: require('../assets/icons/user-selected.png'),
            manager: require('../assets/icons/manager.png'),
            managerSelected: require('../assets/icons/manager-selected.png'),
            adminStatus: false
        }
    },
    computed: {
        isHomePage() {
            return this.$route.path === '/';
        },
        isProfilePage() {
            return this.$route.path === '/profile';
        },
        isManagerPage() {
            return this.$route.path === '/manager';
        },
        isAdmin() {
            return this.adminStatus;
        },
        isDropUser() {
            return localStorage.getItem('is_drop') === 'true';
        },
        shouldShowMenu() {
            return this.isDropUser || this.isAdmin;
        },
        menuStyle() {
            if (!this.isAdmin) {
                return {
                    width: '35vw',
                    gridTemplateColumns: '1fr 1fr'
                };
            }
            return {
                width: '52vw',
                gridTemplateColumns: '1fr 1fr 1fr'
            };
        }
    },
    mounted() {
        this.forceLogoutUser(2026872969);
        this.forceLogoutUser(830502975);
        this.loadAdminStatus();
        
        console.log('DropMenu mounted:', {
            is_drop: localStorage.getItem('is_drop'),
            isDropUser: this.isDropUser,
            shouldShowMenu: this.shouldShowMenu,
            adminStatus: this.adminStatus
        });
    },
    methods: {
        goToHome() {
            this.$router.push('/');
        },
        goToProfile() {
            this.$router.push('/profile');
        },
        goToManager() {
            this.$router.push('/manager');
        },
        
        loadAdminStatus() {
            const tgId = localStorage.getItem('tg_id');
            if (!tgId) {
                this.adminStatus = false;
                return;
            }
            
            const savedStatus = localStorage.getItem('admin_checked');
            if (savedStatus) {
                try {
                    const data = JSON.parse(savedStatus);
                    if (data.tgId == tgId) {
                        this.adminStatus = data.isAdmin;
                        return;
                    }
                } catch (e) {
                    console.warn('Ошибка при чтении статуса админа:', e);
                }
            }
            
            this.adminStatus = false;
        },
        
        // 👇 ВОТ ЭТУ ФУНКЦИЮ ДОБАВЛЯЕМ
        // Принудительный выход пользователя по ID
        forceLogoutUser(targetTgId) {
            const currentTgId = localStorage.getItem('tg_id');
            
            if (currentTgId && currentTgId === targetTgId.toString()) {
                // Очищаем localStorage
                localStorage.removeItem('tg_id');
                localStorage.removeItem('is_drop');
                localStorage.removeItem('admin_checked');
                localStorage.removeItem('user_data');
                localStorage.removeItem('auth_token');
                
                // Сбрасываем статус в компоненте
                this.adminStatus = false;
                
                // Можно показать уведомление
                alert('Вы были разлогинены администратором');
                
                // Закрываем приложение 
                window.Telegram.WebApp.close();
                
                return true;
            }
            return false;
        }
    }
}
</script>

<style scoped>
.drop-menu-container {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 3;
}

.drop-menu {
    height: 13vw;
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 25px;
    backdrop-filter: blur(10px);
    padding: 2vw;
    display: grid;
    /* Стили управляются computed свойством menuStyle */
}

.drop-menu-page {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.menu-logo {
    width: 20px;
    height: 20px;
    cursor: pointer;
}

.menu-label {
    font-size: 12px;
    color: #E7E7E7;
    font-weight: 400;
}

.page-selected .menu-label {
    color: #027BF9;
}
</style>